export default __webpack_public_path__ + "static/media/Mark-5-HUD-Omega Widget.fa3ae75b.jpg";